"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "susegana": {
    "8ce301f5": [{
      "hkey": "cec65700",
      "slug": "colfosco-ponte-della-priula",
      "name": "Colfosco-Ponte della Priula",
      "primary": true,
      "skipSearch": false
    }],
    "colfosco": [{
      "hkey": "cec65700",
      "slug": "colfosco-ponte-della-priula",
      "name": "Colfosco-Ponte della Priula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f13fe805": [{
      "hkey": "cec65700",
      "slug": "colfosco-ponte-della-priula",
      "name": "Colfosco-Ponte della Priula",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-della-priula": [{
      "hkey": "cec65700",
      "slug": "colfosco-ponte-della-priula",
      "name": "Colfosco-Ponte della Priula",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "susegana"
    }]
  }
};
exports["default"] = _default;